// extracted by mini-css-extract-plugin
export default {"custom":"accordion_custom__aYckc","heading":"accordion_heading__qzLQ+"};